import React from 'react';
import { Wrapper, ResultsTitle, DataContainer, DataItem, CWELink } from './styled';

const CWE = ({ currentVuln }) => {
  const validCwes = (currentVuln.cwe || []).filter(Boolean);

  if (validCwes.length === 0) return null;

  const isOdd = (n) => n % 2 !== 0;

  return (
    <Wrapper>
      <ResultsTitle>CWE</ResultsTitle>
      <DataContainer>
        {validCwes.map((item, i) => (
          <DataItem key={ item } isOdd={ isOdd(i) }>
            <CWELink
              href={ `https://cwe.mitre.org/data/definitions/${item.replace('CWE-', '').replace('cwe-', '')}.html` }
              target="_blank"
              rel="noopener noreferrer"
            >
              {item}
            </CWELink>
          </DataItem>
        ))}
      </DataContainer>
    </Wrapper>
  );
};

export default CWE;
